import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import FronkPage from "@/pages/FronkPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FronkPage />} />
      </Routes>
      <Toaster position="bottom-center" richColors />
    </BrowserRouter>
  );
}

export default App;
